import Icon from '../components/Icon.vue'

Icon.register({
  transgender: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M372 0H293C282.3 0 277 12.9 284.5 20.5L301.4 37.4 220.7 118.1C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240 0 308.5 47.9 365.9 112 380.4V408H76C69.4 408 64 413.4 64 420V460C64 466.6 69.4 472 76 472H112V500C112 506.6 117.4 512 124 512H164C170.6 512 176 506.6 176 500V472H212C218.6 472 224 466.6 224 460V420C224 413.4 218.6 408 212 408H176V380.4C240.1 365.8 288 308.5 288 240 288 211.8 279.9 185.5 265.9 163.3L346.6 82.6 363.5 99.5C371.1 107.1 384 101.7 384 91V12C384 5.4 378.6 0 372 0zM144 320C99.9 320 64 284.1 64 240S99.9 160 144 160 224 195.9 224 240 188.1 320 144 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/transgender.js
// module id = O4N+
// module chunks = 144